import React from "react";
import resources from "../lang/resources";

export const Footer = () => {
  const availablesLanguages = Object.keys(resources);

  return (
    <footer className="bg-gray-600 text-white py-2">
      <div className="container mx-auto text-center">
        © PonziLover.com <span className="text-sm">(01.121)</span>
        {availablesLanguages
          .map((lang) => {
            return <span key={lang}> | <a href={`/${lang}/home`}>{lang.toUpperCase()}</a></span>
          })
        }
      </div>
    </footer>
  );
};
